import React, { useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import styled from 'styled-components';
import InvoiceIcon from '../../../../generic/icons/IconLib/InvoiceIcon';
import PackageIcon from '../../../../generic/icons/IconLib/PackageBoxIcon';
import PalletIcon from '../../../../generic/icons/IconLib/PalletIcon';
import ScalesIcon from '../../../../generic/icons/IconLib/ScaleIcon';
import UserIcon from '../../../../generic/icons/IconLib/UserIcon';
import TitlesList from '../../../../generic/titlesRowItem/TitlesList';
import PalletItem from './PalletItem';

const MainWrapper = styled.div`
    width: 100%;
    user-select: none;
    border-radius: 30px;
    background: ${props => props.$hasPallet ? 'rgba(41,127,126, 0.8)' : '#eff3f4'} ;
    display: flex;
    flex-flow: column;
    padding: 0.5em;
    gap: 0.5em;
    /* filter: drop-shadow(4px 3px 3px rgba(41,127,118,0.51)); */
    
`

const TitleWrapper = styled.div`
    width: 100%;
    min-height: 5em;
    background: #fff;
    display: flex;
    flex-flow: column;
    border-radius: 20px;
    padding: .5em;
    gap: 0.3em;

`
const TitleItem = styled.div`
    width: 100%;
    /* padding: 0 0.5em; */
    max-height: 1.1em;
    overflow: hidden;
    text-align: start;
    /* background: yellow; */
    display: inline-flex;
    justify-content: flex-end;
    color: #75759e;
    flex-flow: ${props => props.$reversed ? 'row' : 'row-reverse'};
    gap: 0.5em;
   

`
const Checker = styled.div`
    position: absolute;
    width: 2em;
    height: 2em;
    background: red;
`

const NestedItemsContainer = styled.div`
    /* height: 100%; */
    padding: 0.5em 0;
    /* background: rgba(41,127,118,0.51); */
    /* border-radius: 0 0 20px 20px; */
    display: ${props => props.$isOpen ? 'flex' : 'none'};
    flex-flow: column;
    gap: 0.5em;
`

function InnerGroupContainer({ 
    index, OrderID, pallets, collectDragPallets, PalletTransferZone, Customer_Name, reversed, 
    Status, PalletsQty, Width, Custom, Products, statusListAvalibleToCollectInPallet
}) {
    const [isOpen, setIsOpen] = useState(false);
    const widthCalc = Math.round(pallets?.reduce((acc, cur) => {
        acc += cur.GrossWeight
        return acc
    }, 0))
    const {calcPalletsQty, calcProductsQty} = pallets.reduce((acc, cur) => {
        
        acc['calcProductsQty'] = acc['calcProductsQty'] ? acc['calcProductsQty'] + cur.Total_Packages : cur.Total_Packages
        acc['calcPalletsQty'] = acc['calcPalletsQty'] ? acc['calcPalletsQty'] + cur.Total_Pallets : cur.Total_Pallets
        return acc
    }, {})
    
    const addictionalData = {
        collectDragPallets: collectDragPallets
    }
    // console.log(Status)
    const allowToDragPallet = (status) => {
        return statusListAvalibleToCollectInPallet.some(e => e === status)
    }
    
    const isAllowForDrag = allowToDragPallet(Status);

    const sortable = useSortable({ id: OrderID?.toString() + PalletTransferZone })
    const sortableStyle = {
        transform: CSS.Transform.toString(sortable.transform),
        transition: sortable.transition,
        opacity: sortable.isDragging ? 0.5 : 1,
    }

    return (
                    <MainWrapper
                        ref={sortable.setNodeRef}
                        style={sortableStyle}
                        {...sortable.attributes}
                        {...sortable.listeners}
                        $hasPallet={isAllowForDrag}

                    >


                        <TitleWrapper
                            $isOpen={isOpen && isAllowForDrag}
                            onClick={() => {setIsOpen(!isOpen)}}
                        >
                            <TitleItem
                                $reversed={reversed}
                                data-tooltip-id={`customerNameTip${OrderID}`}
                                data-tooltip-content={Customer_Name?.trim()}
                            >
                                {Customer_Name?.trim()}
                                <UserIcon />
                            </TitleItem>
                            <ReactTooltip id={`customerNameTip${OrderID}`} place="top" />
                            <TitleItem $reversed={reversed}>
                                {OrderID}
                                <InvoiceIcon />
                            </TitleItem>
                            <TitleItem $reversed={reversed}>
                                {Custom ? Products : calcProductsQty}
                                <PackageIcon />

                                {Custom ? PalletsQty : calcPalletsQty}
                                <PalletIcon />
                            </TitleItem>
                            <TitleItem $reversed={reversed}>
                                {Width || widthCalc}
                                <ScalesIcon />
                            </TitleItem>
                        </TitleWrapper>
                        <NestedItemsContainer
                            $isOpen={isOpen && isAllowForDrag}
                        >
                            <TitlesList
                                list={pallets}
                                uniqueKey={'Pallet_Num'}  
                                Element={PalletItem}  
                                additionalData={addictionalData} 
                            />
                        </NestedItemsContainer>

                    </MainWrapper>
    );
}

export default InnerGroupContainer;